<template>
  <!-- 卸货作业单 UnloadingOperationSheet_list-->
  <div class="container">
    <!-- 按钮列表 -->
    <div class="glo_btnList" ref="btnList">
      <div class="glo_btnList_left">
        <el-button class="glo_btnItems" @click="batchCheckFee()" v-permission="'admin:dispatch:xiehuozuoyedan:check'"
          >批量过账</el-button
        >
        <el-button class="glo_btnItems" @click="batchCheckFeeOut()" v-permission="'admin:dispatch:xiehuozuoyedan:uncheck'"
          >批量反过账</el-button
        >
        <el-button class="glo_btnItems" @click="cancelList()" v-permission="'admin:dispatch:xiehuozuoyedan:revoke'">作废</el-button>
        <el-button class="glo_btnItems" @click="deleteList()" v-permission="'admin:dispatch:xiehuozuoyedan:del'">删除</el-button>
        <el-button class="glo_btnItems" @click="printEvent()"
          >打印货物装货清单</el-button
        >
        <el-dropdown class="topDropDown" @command="topCommandBtns">
          <el-button type="primary">
            更多操作<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="dtdc">导出</el-dropdown-item>
            <el-dropdown-item command="bgsz">表格设置</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <queryBtns
        :MoreConditions="MoreConditions"
        @clerBtns="clerBtns"
        @queryBtn_ok="queryBtn_ok"
        @moreParam="moreParam"
      ></queryBtns>
    </div>
    <!-- 查询条件 -->
    <queryCondition
      ref="queryForm"
      :More="isHaseMore"
      :formConfig="queryCondditionDatas"
    ></queryCondition>
    <!-- 表格 -->
    <mytable
      ref="mytable"
      :tableHeigth="tableHeigth"
      :tableData="tableData"
      :myTableHeard="myTableHeard"
      :isShowOperate="isShowOperate"
      :isShowMoreOperate="isShowMoreOperate"
      :btnsList="btnsList"
      :btnsMoreList="btnsMoreList"
      :Operatewidth="Operatewidth"
      @handleCommandBtns="handleCommandBtns"
    ></mytable>
    <paging
      ref="pags"
      :pageNum="pageStart"
      :total="pageCount"
      :size="pageTotal"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
    ></paging>
    <!--        自定义表头           -->
    <sorttable
      :show_sortTableHeard="show_sortTableHeard"
      :allCheck="allCheck"
      :sortName="sortName"
      :tabelHeadeTitle="tabelHeadeTitle"
      :originalTabelHeadeTitle="originalTabelHeadeTitle"
      :selectLength="selectLength"
      @cancelSortHeard="cancelSortHeard"
      @confirmOk="confirmOk"
      @checktab="checktab"
      @checkAll="checkAll"
      @closeDias="closeDias"
    ></sorttable>

    <!-- 导出 -->
    <exportCompoent
      :isShowDialog_dc="isShowDialog_dc"
      :diaWidth_dc="diaWidth_dc"
      :dialogTitle_dc="dialogTitle_dc"
      :dialogForm_dc="dialogForm_dc"
      :tableHeard="EPtableHeard"
      :AllCheck="EPAllCheck"
      :queryCondditionDatas="queryCondditionDatas"
      @checktabEP="checktabEP"
      @checkAllEP="checkAllEP"
      @onAfterEnter="onAfterEnter"
      @handleCloseDia_dc="handleCloseDia_dc"
      @diaConfirmBtn_dc="diaConfirmBtn_dc()"
    >
    </exportCompoent>
    <my-print
      :classNameArr="classNameArr"
      :modelClassName.sync="modelClassName"
      modelTypeVal="调度配载模块"
      ref="myPrint"
      :dataSource="printDataSource"
      :add-permission="'admin:dispatch:xiehuozuoyedan:print:add:common'"
      :edit-permission="'admin:dispatch:xiehuozuoyedan:print:del:common'"
      :del-permission="'admin:dispatch:xiehuozuoyedan:print:del:common'"
    ></my-print>
  </div>
</template>

<script>
import tableListNew from "@/pages/tableListNew.js"; //mixins 查询列表页公共方法
import sorttable from "@/components/sortTemplate.vue"; //自定义排序表头
import paging from "@/components/pagings.vue"; //分页组件
import myDialog from "@/components/Dialog.vue";
import mytable from "@/components/table/table.vue";
import queryCondition from "@/components/queryCondition.vue";
import queryBtns from "@/components/queryBtns.vue";
import exportjs from "@/assets/js/Mixins/exportDT.js"; //导出的公共js
import colorStatus from "@/assets/js/Mixins/colorStatus.js"; //导出的公共js
import MyPrint from "@/components/print/MyPrint.vue";
export default {
  inject: ["reload"],
  mixins: [tableListNew, exportjs, colorStatus],
  components: {
    queryCondition,
    sorttable,
    paging,
    myDialog,
    queryBtns,
    mytable,
    MyPrint
  },
  data() {
    return {
      pageGroupName: "LoadingUnOperationSheet", //  页面标识
      reportFiledsNumber: "admin_dispatch_unload_list_v5", // 动态 条件、表头
      isShowOperate: true, //是否显示右边操作
      isShowMoreOperate: false, //是否显示右边更多操作
      dialogForm_dc:{
        fileName:'卸货作业单',
        pageType: "LoadingUnOperationSheet"
      },
      // 表格右边操作按钮
      btnsList: [
        {
          name: "修改", //按钮名称
          methods: "dispatchEdit", //当前页面的方法
          param: 1, //自定义参数标记
          permission:'admin:dispatch:xiehuozuoyedan:edit'
        },
        {
          name: "费用录入",
          methods: "costEntry",
          param: 2,
          show: true,
          permission:'admin:dispatch:xiehuozuoyedan:fee:checkin'
        },
        {
          name: "详情",
          methods: "dispatchDetail",
          param: 3,
          show: true,
          permission:'admin:dispatch:xiehuozuoyedan:detail'
        },
      ],
      // 表格右边更多的操作按钮
      btnsMoreList: [],
      Operatewidth: "220px", //操作列的列宽
      // queryCondditionDatas: [
      //   {
      //     conditonKey: "dispatchType",
      //     conditonVal: 'gan_xian_pei_zai:dispatch_type',
      //   },
      // ],
      classNameArr: [
        {
          name: "发车单",
          val: "com.bami.service.tms.v5.admin.dispatch.vo.print.AdminDispatchFcPrintDataV5VO",
        },
      ], // 默认的模板类型
      modelClassName:
        "com.bami.service.tms.v5.admin.dispatch.vo.print.AdminDispatchFcPrintDataV5VO",
    };
  },
  methods: {
    // 批量过账
    batchCheckFee() {
      if (this.selectTableData.length !== 1) {
        this.$message.warning("请选择一条运单进行操作");
        return;
      }
      this.$confirm("是否对已选数据进行财务审核过账？")
        .then((res) => {
          this.$API
            .postingUnloadOrderFinance({
              loadOrderIds: this.selectTableData.map(
                (item) => item.loadOrderId
              ),
            })
            .then((res) => {
              this.$message("过账成功");
              this.getData();
            });
        })
        .catch((err) => {});
    },
    // 批量反过账
    batchCheckFeeOut() {
      if (this.selectTableData.length !== 1) {
        this.$message.warning("请选择一条运单进行操作");
        return;
      }
      this.$confirm("是否对已选数据进行反过账？")
        .then((res) => {
          this.$API
            .backPostingUnloadOrderFinance({
              loadOrderIds: this.selectTableData.map(
                (item) => item.loadOrderId
              ),
            })
            .then((res) => {
              this.$message("反过账成功");
              this.getData();
            });
        })
        .catch((err) => {});
    },
    // 作废
    cancelList() {
      if (this.selectTableData.length > 0) {
        let ids = this.selectTableData.map((item) => item.dispatchId);
        this.$confirm("是否对已选数据进行作废？").then((res) => {
          this.$API
            .cancelUnloadOrder({
              loadOrderIds: this.selectTableData.map(
                (item) => item.loadOrderId
              ),
            })
            .then((res) => {
              this.$message("删除成功");
              this.getData();
            });
        });
      } else {
        this.$message.warning("请选择表格记录！");
      }
    },
    // 删除
    deleteList() {
      if (this.selectTableData.length > 0) {
        let ids = this.selectTableData.map((item) => item.dispatchId);
        this.$confirm("是否对已选数据进行删除？").then((res) => {
          // this.$API
          //   .delDispatch({
          //     dispatchIds: ids,
          //   })
          //   .then((res) => {
          //     this.$message("删除成功");
          //     this.getData();
          //   });
        });
      } else {
        this.$message.warning("请选择表格记录！");
      }
    },
    // 跳转修改
    dispatchEdit(row) {
      this.$router.push({
        path: "/DispatchCar/EditUnloadingOperationSheet",
        query: {
          loadOrderId: row.loadOrderId,
        },
      });
    },
    // 费用录入
    costEntry(row) {
      this.$router.push({
        path: "/DispatchCar/UnloadingShippingExpenseEntry",
        query: {
          loadOrderId: row.loadOrderId,
        },
      });
    },
    // 跳转详情
    dispatchDetail(row) {
      this.$router.push({
        path: "/DispatchCar/UnloadingOperationSheetDetails",
        query: {
          loadOrderId: row.loadOrderId,
        },
      });
    },
    // 顶部跟多按钮的操作
    topCommandBtns(command) {
      if (this.topCommandBtnsBak(command)) {
        return;
      }
      if (this.selectTableData.length == 0) {
        this.$message.warning("请先选择表格记录！");
        return;
      }
      this[command]();
    },

    handleCommandBtns(command, data) {
      this[command](data);
    },
    printDataSource(rows) {
      return new Promise((resolve, reject) => {
        this.$API
          .unLoadFcPrintData({
            unLoadIds: rows.map(d=>d.loadOrderId)
          })
          .then((res) => {
            const result = res.data.result;
            resolve(result);
          })
          .catch((err) => {});
      });
    }
  },
};
</script>

<style lang="less" scoped>
.tableBox {
  height: calc(100% - 260px);
}

.colorStyle {
  color: #f00;
}

.mdTitName {
  height: 24px;
  border: 1px solid #d7d7d7;
  text-align: center;
  min-width: 100px;
}

.queryCriteria {
  .queryItem_one {
    .queryTextarea {
      border: 1px solid #d7d7d7;
    }
  }

  .timeBox {
    border: 1px solid #d7d7d7;
  }
}

.headerboxs {
  width: 100%;
  padding: 5px 0;
  display: flex;
  align-items: center;
}

.iconInput {
  display: flex;
  align-items: center;
}
.mainCOlorBtns {
  background-color: #f0a261;
  color: #fff;
  border: none;
}
.mainCOlorBtns :hover {
  color: #fff;
}
</style> 